module.exports = __webpack_public_path__ + "static/img/joinUs_04_m.992f01be.jpg";